import { Pipe, PipeTransform } from '@angular/core';

import moment from 'moment-timezone';

@Pipe({ name: 'trDateFormat' })
export class DateFormatPipe implements PipeTransform {
  transform(date: Date | number | string, format = 'M/D h:mm a', timezone?: string): string {
    if (date === 0 || date === null) {
      return '-';
    }

    let time = moment(date);

    if (timezone) {
      time = time.tz(timezone) || time;
    }

    return time.format(format);
  }
}
